import React, { Component, PropTypes } from 'react';
import { teamNameWithDivision } from '../../filters/TeamFilters';
import ColoredLabel from '../../common/components/ColoredLabel';
import _ from 'underscore';
import { isBlank } from 'underscore.string';
import Separated from '../../common/components/Separated';

export default class TeamOption extends Component {
  static propTypes = {
    team: PropTypes.object.isRequired,
    renderAcronym: PropTypes.bool,
    showNumGames: PropTypes.bool
  };

  static defaultProps = {
    renderAcronym: true,
    showNumGames: true
  };

  getTeamName() {
    const { team, showNumGames } = this.props;
    const gamesText = (team.numGames !== 1 ? 'Games' : 'Game');

    return _.filter([
      teamNameWithDivision(team),
      showNumGames ? `${team.numGames} ${gamesText}` : null
    ], s => !isBlank(s))
      .join(' - ');
  }

  render() {
    const { team, renderAcronym, showNumGames, ...rest } = this.props;

    const {
      name: teamName,
      numGames,
      pool: {
        name: poolName,
        division: {
          name: divisionName,
          tourney: { acronym, color }
        }
      }
    } = team;

    return (
      <Separated separator=" " {...rest}>
        <span>
          {
            renderAcronym &&
            <ColoredLabel className="mg-right-sm" color={color}>{acronym}</ColoredLabel>
          }
        </span>
        <strong>{teamName}</strong>
        <span>({divisionName})</span>
        <span>
          {
            showNumGames &&
            <em>{numGames} {numGames !== 1 ? 'Games' : 'Game'}</em>
          }
        </span>
      </Separated>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/options/TeamOption.jsx